function Development() {
    return (
      <div className="Development">
        <footer className="Development-footer">
            <ul>
               <p className="textDesenvolvimento">Desenvolvido por <b><a href="https://www.github.com/tiagolucasoo" target="_blank">Tiago Lucas</a></b>  •  2026</p> 
            </ul>
        </footer>
      </div>
    );
  }
  
  export default Development;
  